import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import type { DonationConfig, ImpactItem, TrustPoint } from "@/lib/types";

export function useDonationConfig() {
  const [config, setConfig] = useState<DonationConfig | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    supabase
      .from("donation_config")
      .select("*")
      .eq("id", 1)
      .maybeSingle()
      .then(({ data }) => {
        if (active && data) setConfig(data as DonationConfig);
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, []);

  const amounts: number[] =
    config && config.amounts && config.amounts.length > 0
      ? config.amounts
      : [];

  const trustPoints: TrustPoint[] =
    config && config.trust_points && config.trust_points.length > 0
      ? config.trust_points
      : [];

  const impactItems: ImpactItem[] =
    config && config.impact_items && config.impact_items.length > 0
      ? config.impact_items
      : [];

  const stripeEnabled =
    config && typeof config.stripe_enabled === "boolean"
      ? config.stripe_enabled
      : true;

  const paypalEnabled =
    config && typeof config.paypal_enabled === "boolean"
      ? config.paypal_enabled
      : true;

  return { amounts, trustPoints, impactItems, stripeEnabled, paypalEnabled, loading };
}